var InFlight = InFlight || {};

InFlight.categorizations = (function () {
  var cache = {};
  window.cache = cache;

  var searchUNSPSC = function (searchFunction, searchPayload) {
    var url = '/ws/' + searchFunction;

    return new Promise(function (resolve, reject) {
      $.ajax({
        type: 'POST',
        url: url,
        data: JSON.stringify(searchPayload),
        contentType: 'application/json; charset=utf-8',
        dataType: 'json'
      }).then(
        function (results) {
          resolve(results ? results : { count: 0 });
        },
        function () {
          reject();
        }
      );
    });
  };

  var cacheResult = function (result) {
    if (result) {
      for (var i = 0; i < result.items.length; i++) {
        var pair = result.items[i];
        cache[pair.code] = pair.title;
      }
    }
  };

  var searchByCode = function (codeToSearch) {
    return searchUNSPSC('SearchByCode', { code: codeToSearch });
  };

  var searchByTitle = function (titleToSearch) {
    return searchUNSPSC('SearchByTitle', { title: titleToSearch });
  };

  var search = function (keywords) {
    return searchUNSPSC('Search', { keywords: keywords });
  };

  var getNodeId = function (code, type) {
    return searchUNSPSC('GetNodeId', { code: code, type: type}, );
  }

  var getCategoryByNodeId = function (nodeId) {
    return searchUNSPSC('GetByNodeId', { nodeId: nodeId });
  }

  var getByCode = function (code) {
    if (cache[code]) {
      return Promise.resolve({
        d: {
          code: code,
          title: cache[code]
        }
      });
    }

    var promise = new Promise(function (resolve, reject) {
      searchUNSPSC('GetByCodes', { codes: code }).then(function (result) {
        if (result && result.items && result.items.length > 0) {
          cacheResult(result);
          resolve({
            d: {
              code: code,
              title: result.items[0].title
            }
          });
        } else {
          reject();
        }
      });
    });

    return promise;
  };

  var cacheCode = function (code, title) {
    cache[code] = title;
  };

  var toTopLevelCode = function (code) {
    return code;
    if (code && code.length > 2) {
      return code.substring(0, 3) + '00';
    }
  };

  return {
    toTopLevelCode: toTopLevelCode,
    search: search,
    searchByCode: searchByCode,
    searchByTitle: searchByTitle,
    getByCode: getByCode,
    cacheCode: cacheCode,
    getNodeId: getNodeId,
    getCategoryByNodeId: getCategoryByNodeId
  };
})();
